module.exports = __webpack_public_path__ + "fonts/Helvetica-Bold.ed57aca.ttf";